/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

const CLIENT_ID_KEY = 'pa-agent-client-id';

let fallbackClientId: string | undefined;

/**
 * Id of this browser tab, sent with each turn. The agent's app commands carry it back, so only
 * the tab the user is talking to applies them. Session storage is per tab and survives reloads.
 */
export function getAgentClientId() {
  try {
    const stored = sessionStorage.getItem(CLIENT_ID_KEY);
    if (stored) return stored;
    const created = crypto.randomUUID();
    sessionStorage.setItem(CLIENT_ID_KEY, created);
    return created;
  } catch {
    fallbackClientId ??= crypto.randomUUID();
    return fallbackClientId;
  }
}
